import React, { useState, useEffect } from 'react';
import './Fonts.css';
import './App.css';
import './AppMobile.css';
import './AppTablet.css';
import './SkillCards.css';
import Header from './Header';
import Footer from './Footer';
import RotatingTitle from './RotatingTitle.js';
import myImage from './Imgs/HeroImage.png';
import Figma from './Imgs/Figma.svg';
import Wordpress from './Imgs/Wordpress.svg';
import ReactLogo from './Imgs/React.svg';
import UnrealEngine from './Imgs/UnrealEngine.svg';
import CPlusPlus from './Imgs/CPlusPlus.svg';
import Blender from './Imgs/Blender.svg';
import Javascript from './Imgs/Javascript.svg';
import CSS from './Imgs/CSS.svg';
import HTML from './Imgs/HTML.svg';
import CSharp from './Imgs/CSharp.svg';
import Python from './Imgs/Python.svg';
import Java from './Imgs/Java.svg';
import CaraTeriCollage from './Imgs/CaraTeriCollage.jpg';
import CaraTeriCollageLowQuality from './Imgs/CaraTeriCollageLowQuality.jpg';
import DressToImpress from './Imgs/DressToImpress.jpg';
import ImpressYourCat from './Imgs/ImpressYourCat.jpg';
import NoFishyBusiness from './Imgs/NoFishyBusiness.png';
import PutABowOnIt from './Imgs/PutABowOnIt.jpg';
import DressToImpressLowQuality from './Imgs/DressToImpressLowQuality.jpg';
import ImpressYourCatLowQuality from './Imgs/ImpressYourCatLowQuality.jpg';
import NoFishyBusinessLowQuality from './Imgs/NoFishyBusinessLowQuality.jpg';
import BoutiqueCaraTeri from './Imgs/BoutiqueCaraTeri.PNG';
import BoutiqueCaraTeriBoudoire from './Imgs/BoutiqueCaraTeriBoudoire.PNG';
import BoutiqueCaraTeriContact from './Imgs/BoutiqueCaraTeriContact.PNG';
import DashboardAdmin from './Imgs/DashboardAdmin.PNG';
import GameFramePresentation from './Imgs/GameFramePresentation.PNG';
import GameFramePresentation2 from './Imgs/GameFramePresentation2.PNG';
import StartingPointDigitalHero from './Imgs/StartingPointDigitalHero.PNG';
import StartingPointDigital2 from './Imgs/StartingPointDigital2.PNG';
import StartingPointDigital3 from './Imgs/StartingPointDigital3.PNG';
import MusicFestival from './Imgs/MusicFestival.png';
import MusicFestivalFull from './Imgs/MusicFestivalFull.png';
import PersonalTrainer from './Imgs/PersonalTrainer.png';
import PersonalTrainerFull from './Imgs/PersonalTrainerFull.png';
import Pizzeria from './Imgs/Pizzeria.png';
import PizzeriaFull from './Imgs/PizzeriaFull.png';


import PutABowOnItLowQuality from './Imgs/PutABowOnItLowQuality.jpg';
import FullscreenImage from './FullscreenImage';
import Loader from './Loader';
import useInView from "./useInView";

import CardAnim from './Videos/CardAnim.webm';
import SkillCards from './SkillCards.js';
import ContactForm from './ContactForm.js';
import WobbleButton from './WobbleButton.js';
import EyeTrackingImage from './EyeTrackingImage.js';
import SkillGrid from './SkillGrid.js';
import MediaCarousel from './MediaCarousel.js';
/*import DinoGameWidget from './DinoGameWidget.js';
import PostersAnim from './Videos/CaraTeriPosterAnim.mp4';
import Canvas from './Canvas.js';*/



function App() {

  

  const [screenSize, setScreenSize] = useState('desktop');


  const updateScreenSize = () => {
    if (window.innerWidth < 481) {
      setScreenSize('mobile');
    } else if (window.innerWidth >= 481 && window.innerWidth < 769) {
      setScreenSize('tablet');
    } else {
      setScreenSize('desktop');
    }
  };

  useEffect(() => {
    updateScreenSize(); // Set initial screen size on mount
    window.addEventListener('resize', updateScreenSize); // Update on window resize
    return () => window.removeEventListener('resize', updateScreenSize); // Clean up the listener
  }, []);

  const [hoveredCategory, setHoveredCategory] = useState(null);
  const [hoverTimeout, setHoverTimeout] = useState(null); // To store the timeout ID

  const handleHover = (category) => {
    // Clear any existing timeout if hovering again
    if (hoverTimeout) {
      clearTimeout(hoverTimeout);
    }
    setHoveredCategory(category);
  };

  const handleLeave = () => {
    // Set a timeout to clear hoveredCategory
    const timeoutId = setTimeout(() => {
      setHoveredCategory(null);
    }, 200); // Adjust the delay time as necessary

    setHoverTimeout(timeoutId); // Save the timeout ID
  };



  const skillCardsData = [
    { description: "UI/UX Design with Figma", imageUrl: Figma, category: 'Web Design' },
    { description: "Web Dev with Wordpress", imageUrl: Wordpress, category: 'Web Design' },
    { description: "Web/App Dev with React", imageUrl: ReactLogo, category: 'Web Design' },
    { description: "Game Dev with Unreal Engine", imageUrl: UnrealEngine, category: 'Game Dev' },
    { description: "Coding with C++", imageUrl: CPlusPlus, category: 'Coding' },
    { description: "3D Modeling with Blender", imageUrl: Blender, category: 'Game Dev' },
    { description: "Coding with Javascript", imageUrl: Javascript, category: 'Web Design' },
    { description: "Web Dev with CSS", imageUrl: CSS, category: 'Web Design' },
    { description: "Web Dev with HTML", imageUrl: HTML, category: 'Web Design' },
    { description: "Coding with C#", imageUrl: CSharp, category: 'Coding' },
    { description: "Coding with Python", imageUrl: Python, category: 'Coding' },
    { description: "Coding with Java", imageUrl: Java, category: 'Coding' },
    // Add other card data similarly
  ];

  // Define the specific cards you want to display
  const specificCards = [
    skillCardsData[0],
    skillCardsData[2],
  ];

  const [loading, setLoading] = useState(true);

  // Simulate the loading process (e.g., waiting for resources to load)
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000); // Set a timeout to simulate page loading
    return () => clearTimeout(timer); // Cleanup the timeout if the component unmounts
  }, []);


  const [heroRef] = useInView(0.2, loading);
  const [aboutRef] = useInView(0.05, loading);
  const [project1Ref] = useInView(0.2, loading);
  const [project1PostersRef] = useInView(0.2, loading);
  const [project2Ref] = useInView(0.2, loading);
  const [project2TemplatesRef] = useInView(0.2, loading);
  const [project3Ref] = useInView(0.2, loading);
  const [project4Ref] = useInView(0.2, loading);

  const [contactRef] = useInView(0.2, loading);

  return (

    <div  className="App">
      {loading ? <Loader /> : null} {/* Show loader until loading is false */}
      <Header />
      <main>
        
        <div style={{ opacity: loading ? 0 : 1, transition: 'opacity 1s' }}>
          {/*<Canvas />*/}
          {screenSize === 'desktop' && (
            <section id="Hero" ref={heroRef} className="Hero fade-in">
              <div class = "HeroContainer">
              <div className="HeroTitle fade-in-left">
                  <h2>
                    {["G", "I", "A", "N", "N", "I"].map((letter, index) => (
                      <span key={index} className="title-letter">{letter}</span>
                    ))}
                  </h2>
                  <h2>
                    {["C", "O", "N", "T", "R", "E", "R", "A", "S"].map((letter, index) => (
                      <span key={index + 6} className="title-letter">{letter}</span>
                    ))}
                  </h2>
                  <h3 id="aka">aka NiceFriendlyGuy</h3>
                </div>
                <br></br>
                <h3 className="fade-in-left delay-1">UI/UX Design</h3>
                <h3 className="fade-in-left delay-2">FullStack Development</h3>
                <h3 className="fade-in-left delay-3">Game Development</h3>
                <div class="separator"></div>
                <h3 className="fade-in-left delay-4">This website is made with</h3>
                <div className="FeaturedSkills fade-in-left delay-4">
                  <div className="FeaturedSkillCards">
                    {specificCards.map((card, index) => (
                      <SkillCards
                        key={index}
                        description={card.description}
                        imageUrl={card.imageUrl}
                        category={card.category}
                        isActive={hoveredCategory === card.category}
                        isBlurred={hoveredCategory && hoveredCategory !== card.category} // Blur if not in the hovered category
                        onHover={handleHover}
                        onLeave={handleLeave}
                      // Pass additional props as needed
                      />
                    ))}
                  </div>
                </div>
                <a id="SeeMore" href="#About" className="fade-in-left delay-4">See more of my skills</a>
              </div>
              <div class="HeroImageContainer">
                <WobbleButton />
                <img src={myImage} height="auto" width="1000px" alt='HeroImage' ></img>
              </div>
            </section>
          )}

          {/*MOBILE*/}
          {screenSize === 'mobile' && (
            <section ref={heroRef} id="Hero" className="Hero fade-in">
              <div class="HeroContainer">
                <div class="HeroImageContainer">
                  <WobbleButton />
                  <img src={myImage} height="auto" width="1000px" alt='HeroImage'></img>
                </div>
                <div className="HeroTitle">
                  <h2>
                    {["G", "I", "A", "N", "N", "I"].map((letter, index) => (
                      <span key={index} className="title-letter">{letter}</span>
                    ))}
                  </h2>
                  <h2>
                    {["C", "O", "N", "T", "R", "E", "R", "A", "S"].map((letter, index) => (
                      <span key={index + 6} className="title-letter">{letter}</span>
                    ))}
                  </h2>
                  <h3 id="aka">aka NiceFriendlyGuy</h3>
                  <br></br>
                </div>
                <div class="spacer"></div>
                <h3 className="fade-in-left delay-1">UI/UX Design</h3>
                <h3 className="fade-in-left delay-2">FullStack Development</h3>
                <h3 className="fade-in-left delay-3">Game Development</h3>
                <div class="separator"></div>
                <h3 id="MadeWith" className="fade-in-left delay-4">This website is made with</h3>
                <div className="FeaturedSkills fade-in-left delay-4">
                  <div className="FeaturedSkillCards">
                    {specificCards.map((card, index) => (
                      <SkillCards
                        key={index}
                        description={card.description}
                        imageUrl={card.imageUrl}
                        category={card.category}
                        isActive={hoveredCategory === card.category}
                        isBlurred={hoveredCategory && hoveredCategory !== card.category} // Blur if not in the hovered category
                        onHover={handleHover}
                        onLeave={handleLeave}
                      // Pass additional props as needed
                      />
                    ))}
                  </div>
                </div>
                <a href="#About" className="fade-in-left delay-4">See more of my skills</a>
              </div>
            </section>
          )}
          {/*TABLET*/}
          {screenSize === 'tablet' && (
            <div>
              <section ref={heroRef} id="Hero" className="Hero fade-in">
                <div class = "HeroContainer">
                  <div className="HeroTitle">
                    <h2>
                      {["G", "I", "A", "N", "N", "I"].map((letter, index) => (
                        <span key={index} className="title-letter">{letter}</span>
                      ))}
                    </h2>
                    <h2>
                      {["C", "O", "N", "T", "R", "E", "R", "A", "S"].map((letter, index) => (
                        <span key={index + 6} className="title-letter">{letter}</span>
                      ))}
                    </h2>
                    <h3 id="aka">aka NiceFriendlyGuy</h3>
                  </div>
                  <br></br>
                  <h3 className="fade-in-left delay-1">UI/UX Design</h3>
                  <h3 className="fade-in-left delay-2">FullStack Development</h3>
                  <h3 className="fade-in-left delay-3">Game Development</h3>
                  <div class="separator"></div>
                  <h3 className="fade-in-left delay-4">This website is made with</h3>
                  <div className="FeaturedSkills fade-in-left delay-4">
                    <div className="FeaturedSkillCards">
                      {specificCards.map((card, index) => (
                        <SkillCards
                          key={index}
                          description={card.description}
                          imageUrl={card.imageUrl}
                          category={card.category}
                          isActive={hoveredCategory === card.category}
                          isBlurred={hoveredCategory && hoveredCategory !== card.category} // Blur if not in the hovered category
                          onHover={handleHover}
                          onLeave={handleLeave}
                        // Pass additional props as needed
                        />
                      ))}
                    </div>
                  </div>
                  <a href="#About" className="fade-in-left delay-4">See more of my skills</a>
                </div>
                <div class="HeroImageContainer">
                  <WobbleButton />
                  <img src={myImage} height="auto" width="1000px" alt='HeroImage'></img>
                </div>
              </section>
            </div>
          )}



          <div id="About" class="separation">
            <div class="separator"></div>
            <h2>About</h2>
            <div class="separator"></div>
          </div>

          <section ref={aboutRef} id="About" className="About fade-in">
            <div class="AboutFirst">
              <div class="AboutTitle">
                <h3 id="Who1">Who am I ?</h3>
                <h3 id="Who2">Passionate about everything computer related, I do it all !</h3>
              </div>
              <div class="AboutPicText">
                <div class="AboutImgContainer" className = "fade-in-left">
                  <EyeTrackingImage />
                </div>
                {screenSize === 'desktop' && (
                  <div class="VerticalSeparator"></div>
                )}
                <div class="AboutText">
                  <RotatingTitle />
                  <h3 id="Who">A little bit about me</h3>
                  <p className="fade-in delay-1">
                    💻 <strong>Tech Enthusiast Since Day One</strong><br />
                    I've been passionate about computers and technology from a young age, diving into programming early on and building a strong foundation in object-oriented languages.</p>
                    <p className="fade-in delay-2">
                    🌐 <strong>Web Mastering</strong><br />
                    These days, I’m channeling those skills into web design and development, crafting sleek, functional websites.</p>
                    <p className="fade-in delay-3">
                    🎮 <strong>Jack of All Trades</strong><br />
                    My interests don’t stop there! I’m also passionate about software development, game design, 3D modeling, and all things tech-related.</p>
                    <p className="fade-in delay-4">
                    ✨ <strong>Creative Meets Technical</strong><br />
                    I love combining creativity with technical expertise, focusing on detail to deliver user-friendly and engaging digital experiences.</p>
                </div>
              </div>
              <div class="Best">
                <h2>What I do best</h2>
                <div class="separator"></div>
                <SkillGrid/>
                {/*<div class="SkillCards">
                  {skillCardsData.map((card, index) => (
                    <SkillCards
                      key={index}
                      description={card.description}
                      imageUrl={card.imageUrl}
                      category={card.category}
                      isActive={hoveredCategory === card.category}
                      isBlurred={hoveredCategory && hoveredCategory !== card.category} // Blur if not in the hovered category
                      onHover={handleHover}
                      onLeave={handleLeave}
                    />
                  ))}
                </div>*/}
              </div>
            </div>
            <div>
            
            </div>
            

          </section>
          {/*<DinoGameWidget/>*/}
          <div class="separation" id="ProjectsSep">
            <div class="separator"></div>
            <h2>Projects</h2>
            <div class="separator"></div>
          </div>

          <section id="Projects" class="Projects">
            <div className='Project'>
            <div ref={project1Ref} class="ProjectsTextCard fade-in">
              <div class="ProjectsFirst">
                <div className="fade-in-left ProjectText">
                  <div class="ProjectLink">
                    <a href="https://boutiquecarateri.ch/"
                      target="_blank"
                      rel="noopener noreferrer">
                      <h2>Cara Teri</h2>
                      <svg width="75" height="75" viewBox="0 0 75 75" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M37.5001 18.75H21.8751C21.0463 18.75 20.2515 19.0792 19.6654 19.6653C19.0794 20.2513 18.7501 21.0462 18.7501 21.875V53.125C18.7501 53.9538 19.0794 54.7487 19.6654 55.3347C20.2515 55.9208 21.0463 56.25 21.8751 56.25H53.1251C53.9539 56.25 54.7488 55.9208 55.3348 55.3347C55.9209 54.7487 56.2501 53.9538 56.2501 53.125V37.5M37.5001 37.5L60.9376 14.0625M46.8751 9.375H65.6251V28.125" stroke="black" stroke-width="7.35243" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </a>
                  </div>
                  <h3>Woman's retro fashion shop</h3>
                  <p class="ProjectDescription">
                    Cara Teri is a local women's fashion shop focused on retro/50's colorful clothing and novelty items. <br></br>I was asked to create a website and branding fitting their existing style with some custom decorating posters.
                  </p>
                </div>
                <div class="Services">
                  <div class="ServicesText">
                    <h3 class="YellowText fade-in-left delay-1">- Web Design</h3>
                    <h3 class="YellowText fade-in-left delay-2">- Web Development</h3>
                    <h3 class="YellowText fade-in-left delay-3">- Posters Design</h3>
                    <h3 class="YellowText fade-in-left delay-4">- Business Cards Design</h3>
                  </div>
                </div>
              </div>
              <div class="VerticalSeparatorProjects"></div>
              <div class="ProjectImages fade-in-right">
                <MediaCarousel
                  items={[
                    { type: "image", src: BoutiqueCaraTeri },
                    { type: "image", src: BoutiqueCaraTeriBoudoire },
                    { type: "image", src: BoutiqueCaraTeriContact },
                    { type: "video", src: CardAnim, autoPlay: true, loop: true, muted: true },
                  ]}
                />
                {/*
                <video class="BusinessCard" muted autoPlay loop width={750} >
                  <source src={CardAnim} type="video/webm"></source>
                  Your browser does not support the video tag.
                </video>
                */}
              </div>
            </div>
            <div ref={project1PostersRef} class="Posters fade-in">
              <FullscreenImage
                thumbnailSrc={CaraTeriCollageLowQuality} // Low-quality thumbnail
                fullImageSrc={CaraTeriCollage}           // High-quality full image
                alt="CaraTeriCollage Poster"
              />
              <FullscreenImage
                thumbnailSrc={DressToImpressLowQuality} // Low-quality thumbnail
                fullImageSrc={DressToImpress}           // High-quality full image
                alt="DressToImpress Poster"
              />
              <FullscreenImage
                thumbnailSrc={ImpressYourCatLowQuality} // Low-quality thumbnail
                fullImageSrc={ImpressYourCat}           // High-quality full image
                alt="ImpressYourCat Poster"
              />
              <FullscreenImage
                thumbnailSrc={NoFishyBusinessLowQuality} // Low-quality thumbnail
                fullImageSrc={NoFishyBusiness}           // High-quality full image
                alt="NoFishyBusiness Poster"
              />
              <FullscreenImage
                thumbnailSrc={PutABowOnItLowQuality} // Low-quality thumbnail
                fullImageSrc={PutABowOnIt}           // High-quality full image
                alt="PutABowOnIt Poster"
              />
            </div>
            </div>

            <div class="separator"></div>

            {/*
              2nd Project
            */}
            <div className='Project'>
            <div ref={project2Ref} class="ProjectsTextCard Flip fade-in">
              <div class="ProjectImages Flip fade-in-left">
                <MediaCarousel
                  items={[
                    { type: "image", src: StartingPointDigitalHero },
                    { type: "image", src: StartingPointDigital2 },
                    { type: "image", src: StartingPointDigital3 },

                  ]}
                />
              </div>
              <div class="VerticalSeparatorProjects Flip"></div>
              <div class="ProjectsFirst Flip">
                <div className="fade-in-right ProjectText Flip">
                  <div class="ProjectLink">
                    <a href="https://StartingPointDigital.ch/"
                      target="_blank"
                      rel="noopener noreferrer">
                      <h2>StartingPointDigital</h2>
                      <svg width="75" height="75" viewBox="0 0 75 75" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M37.5001 18.75H21.8751C21.0463 18.75 20.2515 19.0792 19.6654 19.6653C19.0794 20.2513 18.7501 21.0462 18.7501 21.875V53.125C18.7501 53.9538 19.0794 54.7487 19.6654 55.3347C20.2515 55.9208 21.0463 56.25 21.8751 56.25H53.1251C53.9539 56.25 54.7488 55.9208 55.3348 55.3347C55.9209 54.7487 56.2501 53.9538 56.2501 53.125V37.5M37.5001 37.5L60.9376 14.0625M46.8751 9.375H65.6251V28.125" stroke="black" stroke-width="7.35243" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </a>
                  </div>
                  <h3>Freelance web services for small businesses</h3>
                  <p class="ProjectDescription">
                    A freelance initiative I created to offer affordable web solutions to small local businesses. I built a complete WordPress website for a clothing boutique and designed several Figma mockups. This project allowed me to combine my design skills with fullstack development in a real-world client context.
                  </p>
                </div>
                <div class="Services Flip">
                  <div class="ServicesText">
                    <h3 class="YellowText fade-in-right delay-1">- Web Design</h3>
                    <h3 class="YellowText fade-in-right delay-2">- Web Development</h3>
                    <h3 class="YellowText fade-in-right delay-3">- Website Templates Design</h3>
                    <h3 class="YellowText fade-in-right delay-4">- Project Management</h3>
                  </div>
                </div>
              </div>
            </div>

            <div ref={project2TemplatesRef} class="Posters WebDesign fade-in">
              <FullscreenImage
                thumbnailSrc={MusicFestival} // Low-quality thumbnail
                fullImageSrc={MusicFestivalFull}           // High-quality full image
                alt="Music Festival Website Design Template"
              />
              <FullscreenImage
                thumbnailSrc={PersonalTrainer} // Low-quality thumbnail
                fullImageSrc={PersonalTrainerFull}           // High-quality full image
                alt="Personal Coach Website Design Template"
              />
              <FullscreenImage
                thumbnailSrc={Pizzeria} // Low-quality thumbnail
                fullImageSrc={PizzeriaFull}           // High-quality full image
                alt="Pizzeria Website Design Template"
              />
            </div>
            </div>
            <div class="separator"></div>

            {/* 
                3rd Project
            */}
            <div ref={project3Ref} class="ProjectsTextCard">
              <div class="ProjectsFirst">
                <div className="fade-in-left ProjectText">
                  <div class="ProjectLink">
                    <a href="https://github.com/NiceFriendlyGuy/DevShowcase-Group-Project"
                      target="_blank"
                      rel="noopener noreferrer">
                      <h2>DevShowcase</h2>
                      <svg width="75" height="75" viewBox="0 0 75 75" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M37.5001 18.75H21.8751C21.0463 18.75 20.2515 19.0792 19.6654 19.6653C19.0794 20.2513 18.7501 21.0462 18.7501 21.875V53.125C18.7501 53.9538 19.0794 54.7487 19.6654 55.3347C20.2515 55.9208 21.0463 56.25 21.8751 56.25H53.1251C53.9539 56.25 54.7488 55.9208 55.3348 55.3347C55.9209 54.7487 56.2501 53.9538 56.2501 53.125V37.5M37.5001 37.5L60.9376 14.0625M46.8751 9.375H65.6251V28.125" stroke="black" stroke-width="7.35243" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </a>
                  </div>
                  <h3>Admin Dashboard</h3>
                  <p class="ProjectDescription">
                    As part of a fullstack group project, I designed and implemented a complete admin dashboard for managing users, handling account requests, and visualizing platform statistics for a developer-focused social network.
                  </p>
                </div>

                <div class="Services">
                  <div class="ServicesText">
                    <h3 class="YellowText fade-in-left delay-1">- Admin Dashboard Design</h3>
                    <h3 class="YellowText fade-in-left delay-2">- Team Collaboration</h3>
                    <h3 class="YellowText fade-in-left delay-3">- Fullstack Development</h3>
                    <h3 class="YellowText fade-in-left delay-4">- Git Version Control</h3>

                  </div>
                </div>
              </div>
              <div class="VerticalSeparatorProjects"></div>
              <div class="ProjectImages Solo fade-in-right">
                <MediaCarousel
                  items={[
                    { type: "image", src: DashboardAdmin }
                  ]}
                />
              </div>
            </div>


            <div class="separator"></div>


            {/*
              4th Project
            */}

            <div ref={project4Ref} class="ProjectsTextCard Flip fade-in">
              <div class="ProjectImages Flip fade-in-left">
                <MediaCarousel
                  items={[
                    { type: "image", src: GameFramePresentation },
                    { type: "image", src: GameFramePresentation2 },
                  ]}
                />
              </div>
              <div class="VerticalSeparatorProjects Flip"></div>
              <div class="ProjectsFirst Flip">
                <div className="fade-in-right ProjectText Flip">
                  <div class="ProjectLink">
                    <a href="https://GameFrame.ch/"
                      target="_blank"
                      rel="noopener noreferrer">
                      <h2>GameFrame</h2>
                      <svg width="75" height="75" viewBox="0 0 75 75" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M37.5001 18.75H21.8751C21.0463 18.75 20.2515 19.0792 19.6654 19.6653C19.0794 20.2513 18.7501 21.0462 18.7501 21.875V53.125C18.7501 53.9538 19.0794 54.7487 19.6654 55.3347C20.2515 55.9208 21.0463 56.25 21.8751 56.25H53.1251C53.9539 56.25 54.7488 55.9208 55.3348 55.3347C55.9209 54.7487 56.2501 53.9538 56.2501 53.125V37.5M37.5001 37.5L60.9376 14.0625M46.8751 9.375H65.6251V28.125" stroke="black" stroke-width="7.35243" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </a>
                  </div>
                  <h3>A guessing game webapp</h3>
                  <p class="ProjectDescription">
                    A fullstack guessing game built for my certification final project, showcasing both frontend and backend implementation, with a small admin dashboard for managing questions. The app was developed entirely from start to deployment, with a focus on architecture and functionality over visual design.                  </p>
                </div>

                <div class="Services Flip">
                  <div class="ServicesText">
                    <h3 class="YellowText fade-in-right delay-1">- Fullstack App Architecture</h3>
                    <h3 class="YellowText fade-in-right delay-2">- API Development</h3>
                    <h3 class="YellowText fade-in-right delay-3">- Admin Dashboard Development</h3>
                    <h3 class="YellowText fade-in-right delay-4">- Deployment & Hosting</h3>
                  </div>
                </div>
              </div>
            </div>


          </section>

          <div id="Contact" class="separation">
            <div class="separator"></div>
            <h2>Contact</h2>
            <div class="separator"></div>
          </div>
          <section ref={contactRef} id="Contact" class="Contact fade-in">
            <div class="ContactTitle">
              <h2>In need of some design in your world ?</h2>
              <h3>Here's where you can find me</h3>
            </div>
            <div class="ContactContainer">
              <div class="FirstContact">
                <div class="SvgSocials">
                  <div className="Social fade-in-left delay-1">
                    <button>
                    <a
                      href="https://www.instagram.com/nicefriendlyguy.svg"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <svg
                        viewBox="0 0 119 120"
                        fill="#61dafb"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{ background: 'none' }}
                      >
                        <circle
                          cx="59.4647"
                          cy="59.5951"
                          r="58.4647"
                          stroke="none"
                          stroke-width="2"
                          class="icon-circle"
                        />
                        <path
                          d="M45.2615 24.1577H75.3242C86.7767 24.1577 96.0818 33.4628 96.0818 44.9153V74.978C96.0818 80.4833 93.8948 85.763 90.002 89.6558C86.1092 93.5486 80.8295 95.7356 75.3242 95.7356H45.2615C33.809 95.7356 24.5039 86.4305 24.5039 74.978V44.9153C24.5039 39.41 26.6909 34.1303 30.5837 30.2375C34.4765 26.3447 39.7562 24.1577 45.2615 24.1577ZM44.5457 31.3155C41.1287 31.3155 37.8516 32.6729 35.4353 35.0891C33.0191 37.5054 31.6617 40.7825 31.6617 44.1995V75.6938C31.6617 82.8158 37.4237 88.5778 44.5457 88.5778H76.04C79.457 88.5778 82.7341 87.2204 85.1504 84.8042C87.5666 82.3879 88.924 79.1108 88.924 75.6938V44.1995C88.924 37.0775 83.162 31.3155 76.04 31.3155H44.5457ZM79.082 36.6838C80.2685 36.6838 81.4064 37.1552 82.2454 37.9941C83.0843 38.8331 83.5557 39.971 83.5557 41.1575C83.5557 42.3439 83.0843 43.4818 82.2454 44.3208C81.4064 45.1598 80.2685 45.6311 79.082 45.6311C77.8956 45.6311 76.7577 45.1598 75.9187 44.3208C75.0797 43.4818 74.6084 42.3439 74.6084 41.1575C74.6084 39.971 75.0797 38.8331 75.9187 37.9941C76.7577 37.1552 77.8956 36.6838 79.082 36.6838ZM60.2928 42.0522C65.0388 42.0522 69.5903 43.9375 72.9461 47.2934C76.302 50.6492 78.1873 55.2007 78.1873 59.9467C78.1873 64.6926 76.302 69.2441 72.9461 72.6C69.5903 75.9558 65.0388 77.8411 60.2928 77.8411C55.5469 77.8411 50.9954 75.9558 47.6395 72.6C44.2837 69.2441 42.3984 64.6926 42.3984 59.9467C42.3984 55.2007 44.2837 50.6492 47.6395 47.2934C50.9954 43.9375 55.5469 42.0522 60.2928 42.0522ZM60.2928 49.21C57.4453 49.21 54.7144 50.3412 52.7009 52.3547C50.6873 54.3682 49.5562 57.0991 49.5562 59.9467C49.5562 62.7942 50.6873 65.5251 52.7009 67.5386C54.7144 69.5522 57.4453 70.6833 60.2928 70.6833C63.1404 70.6833 65.8713 69.5522 67.8848 67.5386C69.8983 65.5251 71.0295 62.7942 71.0295 59.9467C71.0295 57.0991 69.8983 54.3682 67.8848 52.3547C65.8713 50.3412 63.1404 49.21 60.2928 49.21Z"
                          fill="#000000"
                          class="icon-path"
                        />
                      </svg>
                      </a>
                    </button>
                    <h3>@NiceFriendlyGuy.svg</h3>
                  </div>
                </div>
                <div class="SvgSocials">
                  <div className="Social fade-in-left delay-2">
                    <button>
                    <a
                      href="https://www.linkedin.com/in/gianni-contreras-0aa58a24a/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <svg
                        viewBox="0 0 119 119"
                        fill="#61dafb"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{ background: 'none' }}
                      >
                        <circle
                          cx="59.4647"
                          cy="59.4647"
                          r="58.4647"
                          stroke="#FFF600"
                          stroke-width="2"
                          class="icon-circle"
                        />
                        <path
                          d="M84.8262 25.7251C86.7793 25.7251 88.6525 26.501 90.0335 27.882C91.4146 29.2631 92.1905 31.1362 92.1905 33.0894V84.6392C92.1905 86.5923 91.4146 88.4655 90.0335 89.8465C88.6525 91.2276 86.7793 92.0035 84.8262 92.0035H33.2764C31.3232 92.0035 29.4501 91.2276 28.0691 89.8465C26.688 88.4655 25.9121 86.5923 25.9121 84.6392V33.0894C25.9121 31.1362 26.688 29.2631 28.0691 27.882C29.4501 26.501 31.3232 25.7251 33.2764 25.7251H84.8262ZM82.9851 82.7981V63.2828C82.9851 60.0992 81.7205 57.046 79.4693 54.7949C77.2182 52.5438 74.165 51.2791 70.9814 51.2791C67.8516 51.2791 64.2063 53.1938 62.4389 56.0659V51.9787H52.1657V82.7981H62.4389V64.6452C62.4389 61.81 64.7218 59.4902 67.557 59.4902C68.9242 59.4902 70.2354 60.0334 71.2021 61.0001C72.1689 61.9669 72.712 63.278 72.712 64.6452V82.7981H82.9851ZM40.1988 46.1978C41.8394 46.1978 43.4128 45.546 44.5729 44.3859C45.733 43.2258 46.3848 41.6524 46.3848 40.0118C46.3848 36.5874 43.6232 33.789 40.1988 33.789C38.5484 33.789 36.9656 34.4446 35.7986 35.6116C34.6316 36.7786 33.976 38.3614 33.976 40.0118C33.976 43.4362 36.7744 46.1978 40.1988 46.1978ZM45.3169 82.7981V51.9787H35.1174V82.7981H45.3169Z"
                          fill="#000000"
                          class="icon-path"
                        />
                      </svg>
                      </a>
                    </button>
                    <h3>Gianni Contreras</h3>
                  </div>
                </div>
                <div class="SvgSocials">
                  <div className="Social fade-in-left delay-3">
                    <button>
                    <a
                      href="#Contact"
                    >
                      <svg
                        viewBox="0 0 102 102"
                        fill="#61dafb"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{ background: 'none' }}
                      >
                        <circle
                          cx="51"
                          cy="51"
                          r="49"
                          stroke="#FFF600"
                          strokeWidth="2"
                          fill="#61dafb"
                          className="icon-circle"
                        />
                        <path
                          d="M28.2454 72.1824C26.735 72.1824 25.4425 71.645 24.3679 70.5704C23.2933 69.4958 22.755 68.2024 22.7532 66.6902V33.7373C22.7532 32.2269 23.2914 30.9344 24.3679 29.8598C25.4444 28.7852 26.7369 28.2469 28.2454 28.2451H72.1826C73.6929 28.2451 74.9863 28.7833 76.0628 29.8598C77.1393 30.9363 77.6766 32.2288 77.6748 33.7373V66.6902C77.6748 68.2005 77.1374 69.4939 76.0628 70.5704C74.9882 71.6469 73.6948 72.1842 72.1826 72.1824H28.2454ZM50.214 52.9598L72.1826 39.2294V33.7373L50.214 47.4677L28.2454 33.7373V39.2294L50.214 52.9598Z"
                          fill="#000000"
                          className="icon-path"
                        />
                      </svg>
                      </a>
                    </button>
                    {screenSize === 'desktop' && (
                      <h3>Contact@GianniContreras.ch</h3>
                    )}
                    {screenSize === 'tablet' && (
                      <h3>Contact@GianniContreras.ch</h3>
                    )}
                    {screenSize === 'mobile' && (
                      <h3>Contact@<br></br>GianniContreras.ch</h3>
                    )}
                  </div>
                </div>

                <div class="SvgSocials">
                  <div className="Social fade-in-left delay-4">
                    <button>
                    <a
                      href="https://github.com/NiceFriendlyGuy"
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      <svg
                        viewBox="0 0 102 102"
                        fill="#61dafb"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{ background: 'none' }}
                      >
                        <circle
                          cx="50"
                          cy="50"
                          r="50"
                          stroke="#FFF600"
                          strokeWidth="2"
                          fill="#61dafb"
                          className="icon-circle"
                        />
                        <path
                          d="M49.9999 8.33337C44.5282 8.33337 39.11 9.41111 34.0548 11.5051C28.9995 13.599 24.4062 16.6682 20.5371 20.5373C12.7231 28.3513 8.33325 38.9494 8.33325 50C8.33325 68.4167 20.2916 84.0417 36.8333 89.5834C38.9166 89.9167 39.5833 88.625 39.5833 87.5V80.4584C28.0416 82.9584 25.5833 74.875 25.5833 74.875C23.6666 70.0417 20.9583 68.75 20.9583 68.75C17.1666 66.1667 21.2499 66.25 21.2499 66.25C25.4166 66.5417 27.6249 70.5417 27.6249 70.5417C31.2499 76.875 37.3749 75 39.7499 74C40.1249 71.2917 41.2083 69.4584 42.3749 68.4167C33.1249 67.375 23.4166 63.7917 23.4166 47.9167C23.4166 43.2917 24.9999 39.5834 27.7083 36.625C27.2916 35.5834 25.8333 31.25 28.1249 25.625C28.1249 25.625 31.6249 24.5 39.5833 29.875C42.8749 28.9584 46.4583 28.5 49.9999 28.5C53.5416 28.5 57.1249 28.9584 60.4166 29.875C68.3749 24.5 71.8749 25.625 71.8749 25.625C74.1666 31.25 72.7083 35.5834 72.2916 36.625C74.9999 39.5834 76.5833 43.2917 76.5833 47.9167C76.5833 63.8334 66.8333 67.3334 57.5416 68.375C59.0416 69.6667 60.4166 72.2084 60.4166 76.0834V87.5C60.4166 88.625 61.0833 89.9584 63.2083 89.5834C79.7499 84 91.6666 68.4167 91.6666 50C91.6666 44.5283 90.5889 39.1101 88.4949 34.0549C86.401 28.9997 83.3318 24.4064 79.4627 20.5373C75.5936 16.6682 71.0003 13.599 65.9451 11.5051C60.8898 9.41111 55.4717 8.33337 49.9999 8.33337Z" 
                          fill="black"
                          className="icon-path"
                        />
                      </svg>
                      </a>
                    </button>
                    {screenSize === 'desktop' && (
                      <h3>Github.com/NiceFriendlyGuy</h3>
                    )}
                    {screenSize === 'tablet' && (
                      <h3>Github.com/NiceFriendlyGuy</h3>
                    )}
                    {screenSize === 'mobile' && (
                      <h3>Github.com/<br></br>NiceFriendlyGuy</h3>
                    )}
                  </div>
                </div>
              </div>
              {screenSize === 'desktop' && (
                <div class="VerticalSeparator"></div>
              )}
              {screenSize === 'mobile' && (
                <div class="separator"></div>
              )}
              <div className="fade-in">
                <ContactForm />
              </div>
            </div>
          </section>
          </div>
      </main>
      <Footer />
    </div>
  );
}

export default App;
